import { Button, Grid } from '@mui/material';
import FileSelectForm from './FileSelectForm';

export default function Group1FileForm({csvForm, onSubmitForm, onChange}) {

  const handleSelectFiles = (files) => {
    
      if (files.length > 0) {
        const file = files[0];

        onChange(
          (prevForm) => ({...prevForm, files: [file]})
        );
      }
    };
   
  const handleClickImport = (_) => {
    onSubmitForm();
  }

  const fileInfo = csvForm.fileInfos.length > 0
            ? csvForm.fileInfos[0]
            : null;

  const disabledImport = !fileInfo;

  return (
    <FileSelectForm>
      <Grid
        container
        columnSpacing={2}
        alignItems="center"
      >
        <Grid item>
          <FileSelectForm.SelectButton
            label='CSVファイル選択'
            onSelectFiles={handleSelectFiles}
            accept='text/csv'
          />
        </Grid>
        <Grid item>
          <FileSelectForm.FileNameDisplay fileName={fileInfo?.name} />
        </Grid>
        <Grid item>
          <FileSelectForm.FileSizeDisplay fileSize={fileInfo?.size} />
        </Grid>
        <Grid item marginLeft='auto'>
          <Button
            variant="contained"
            onClick={handleClickImport}
            disabled={disabledImport}
          >
            取込
          </Button>
        </Grid>
      </Grid> 
    </FileSelectForm>
  );
}